import * as actionTypes from './actionType';
import { message } from 'antd';
import { prepAxiosHeaders } from '../utility';
import i18next from 'i18next';


export const loadContactStarted = () => {
  return {
    type: actionTypes.LOAD_CONTACT_STARTED
  }
}

export const resetContact = () => {
  console.log("-------------- resetContact");
  return {
    type: actionTypes.RESET_CONTACT
  }
}

export const loadContactDone = contact => {
  return {
    type: actionTypes.LOAD_CONTACT_DONE,
    contact_data: contact,
    secs_since_last_call: 0
  }
}

export const loadContactFailed = (error, secs_since_last_call) => {
  return {
    type: actionTypes.LOAD_CONTACT_FAILED,
    contact_error: error,
    secs_since_last_call: secs_since_last_call
  }
}

// getArticle
export const fetchContact = () => {
  return dispatch => {
    dispatch(loadContactStarted());
    let h_axios = prepAxiosHeaders();
    if (h_axios) {
      h_axios.get(window._env_.REACT_APP_API_URL + '/api/agent/get_current_contact/')
        .then(res => {
          // console.log(res.data);
          if (res.data.status === 'OK') {
            dispatch(loadContactDone(res.data.data));
          } else {
            dispatch(loadContactFailed(res.data.status, res.data.data.secs_since_last_call))
          }
        })
        .catch(err => {
          dispatch(loadContactFailed(err, 0))
          console.log("Error loading...");
        })
    } else {
      dispatch(loadContactFailed('Axios headers error...', 0))
    }
  }
}


export const updateDispositionStarted = () => {
  return {
    type: actionTypes.UPDATE_DISPOSITION_STARTED
  }
}

export const updateDispositionDone = () => {
  message.success(i18next.t("Disposition Updated!"), 1);
  return {
    type: actionTypes.UPDATE_DISPOSITION_DONE,
  }
}

export const updateDispositionFailed = error => {
  message.error(i18next.t("Error updating disposition!"), 1);
  return {
    type: actionTypes.UPDATE_DISPOSITION_FAILED,
    disposition_error: error
  }
}

// update disposition
export const updateDisposition = (subscriber_id, disposition) => {
  return dispatch => {
    dispatch(updateDispositionStarted());
    let h_axios = prepAxiosHeaders();
    h_axios.post(window._env_.REACT_APP_API_URL + '/api/agent/update_disposition/',
      {
        subscriber_id: subscriber_id,
        disposition: disposition,
      })
      .then(res => {
        console.log(res.data);
        if (res.data.status === 'OK') {
          dispatch(updateDispositionDone());
        } else {
          dispatch(updateDispositionFailed(res.data.status))
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(updateDispositionFailed(err))
        console.log("Error loading...");
      });
  }
}

// DNC
export const updateDNCStarted = () => {
  return {
    type: actionTypes.UPDATE_DNC_STARTED
  }
}

export const updateDNCDone = () => {
  message.success(i18next.t("DNC Updated!"), 1);
  return {
    type: actionTypes.UPDATE_DNC_DONE
  }
}

export const updateDNCFailed = error => {
  message.error(i18next.t("Error updating DNC!"), 1);
  return {
    type: actionTypes.UPDATE_DNC_FAILED,
    dnc_error: error
  }
}

// update contact on DNC - either add or delete
export const updateDNC = (subscriber_id, add_dnc) => {
  return dispatch => {
    dispatch(updateDNCStarted());
    let h_axios = prepAxiosHeaders();
    h_axios.post(window._env_.REACT_APP_API_URL + '/api/agent/add_on_dnc/',
      {
        subscriber_id: subscriber_id,
        add_dnc: add_dnc,
      })
      .then(res => {
        console.log(res.data);
        if (res.data.status === 'OK') {
          dispatch(updateDNCDone());
        } else {
          dispatch(updateDNCFailed(res.data.status))
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(updateDNCFailed(err))
        console.log("Error loading...");
      });
  }
}


// Note
export const addNoteStarted = () => {
  return {
    type: actionTypes.ADD_NOTE_STARTED
  }
}

export const addNoteDone = () => {
  message.success(i18next.t("Note has been written!"), 1);
  return {
    type: actionTypes.ADD_NOTE_DONE
  }
}

export const addNoteFailed = error => {
  message.error(i18next.t("Error writting the note!"), 1);
  return {
    type: actionTypes.ADD_NOTE_FAILED,
    note_error: error
  }
}

// Add a new Note to a Contact
export const addNote = (subscriber_id, note) => {
  return dispatch => {
    dispatch(addNoteStarted());
    let h_axios = prepAxiosHeaders();
    h_axios.post(window._env_.REACT_APP_API_URL + '/api/agent/add_note/',
      {
        subscriber_id: subscriber_id,
        note: note,
      })
      .then(res => {
        console.log(res.data);
        if (res.data.status === 'OK') {
          dispatch(addNoteDone());
        } else {
          dispatch(addNoteFailed(res.data.status))
        }
      })
      .catch(err => {
        console.log("err:", err);
        dispatch(addNoteFailed(false))
        console.log("Error loading...");
      });
  }
}


// Callback Later
export const addCallbackStarted = () => {
  return {
    type: actionTypes.ADD_CALLBACK_STARTED
  }
}

export const addCallbackDone = () => {
  message.success(i18next.t("Callback has been created!"), 1);
  return {
    type: actionTypes.ADD_CALLBACK_DONE
  }
}

export const addCallbackFailed = error => {
  message.error(i18next.t("Error creating the callback!"), 1);
  return {
    type: actionTypes.ADD_CALLBACK_FAILED,
    callback_error: error
  }
}

// Add a new Callback to a Contact
export const addCallback = (subscriber_id, callback_date) => {
  return dispatch => {
    dispatch(addCallbackStarted());
    let h_axios = prepAxiosHeaders();
    h_axios.post(window._env_.REACT_APP_API_URL + '/api/agent/add_callback/',
      {
        subscriber_id: subscriber_id,
        callback_date: callback_date,
      })
      .then(res => {
        console.log(res.data);
        if (res.data.status === 'OK') {
          dispatch(addCallbackDone());
        } else {
          dispatch(addCallbackFailed(res.data.status))
        }
      })
      .catch(err => {
        console.log("err:", err);
        dispatch(addCallbackFailed(false))
        console.log("Error loading...");
      });
  }
}


// Callback Later
export const updateCallbackStarted = () => {
  return {
    type: actionTypes.UPDATE_CALLBACK_STARTED
  }
}

export const updateCallbackDone = () => {
  message.success(i18next.t("Callback has been updated!"), 1);
  return {
    type: actionTypes.UPDATE_CALLBACK_DONE
  }
}

export const updateCallbackFailed = error => {
  message.error(i18next.t("Error updating the callback!"), 1);
  return {
    type: actionTypes.UPDATE_CALLBACK_FAILED,
    callback_error: error
  }
}

// Add a new Callback to a Contact
export const updateCallback = (callback_id, callback_date, status) => {
  return dispatch => {
    dispatch(updateCallbackStarted());
    let h_axios = prepAxiosHeaders();
    h_axios.post(window._env_.REACT_APP_API_URL + '/api/agent/update_callback/',
      {
        callback_id: callback_id,
        callback_date: callback_date,
        status: status,
      })
      .then(res => {
        console.log(res.data);
        if (res.data.status === 'OK') {
          dispatch(updateCallbackDone());
        } else {
          dispatch(updateCallbackFailed(res.data.status))
        }
      })
      .catch(err => {
        console.log("err:", err);
        dispatch(updateCallbackFailed(false))
        console.log("Error loading...");
      });
  }
}
